import Vue from 'vue'
import Vuex from 'vuex'
import MyHttp from '@/config/myHttp';
import { objHandle } from '@/config/mUtils';
import { setStore, getStore } from '@/config/mUtils';
import MyCrypt from '@/config/myCrypt';
import $statusConfig from '../../statusConfig';

Vue.use(Vuex);

const state = {
  user: {},    //用户id
  partnerConfig: null,
};
const mutations = {
  //存储用户信息
  SET_USER (state, value) {
    state.user = value;
  },
  //初始化用户信息
  INIT_USER (state, user) {
    state.user = user;
  },
  //初始化权限
  INIT_CONFIG(state, _data) {
    state.partnerConfig = _data;
  },
};

const actions = {
  async getUser ({ commit, state }) {
    if (!state.user.userid) {
      let tempdata = window.sessionStorage.getItem('user');
      let data = JSON.parse(MyCrypt.$decrypt(tempdata));
      commit('SET_USER', data);
      return data;
    } else {
      return state.user;
    }
  },
  initUser ({ commit, state }, _user) {
    commit('INIT_USER', _user);
  },
  async getPartnerConfig({ commit, state }) {
    if (!state.partnerConfig) {
      let baseRightUrl = window.location.href
      let rightData = baseRightUrl.split('/');
      console.log('baseRightUrl:', baseRightUrl, rightData);
      let partnerConfig = null;
      // let tempData = JSON.parse(window.sessionStorage.getItem(`partnerConfig`));
      // if (!tempData) {
      if (rightData.length > 4) {
        let nicknames = rightData[3].split('#')
        let [err, rdt] = await MyHttp.$syncPost({ url: '/sop/partner/config/detail', reqdata: { nickname: nicknames[0] } });
        if (err || rdt.rst === 300) {
          commit('INIT_CONFIG', null);
        }
        if (rdt && rdt.rst === 200) {
          if (rdt.data && Object.keys(rdt.data).length > 0) {
            partnerConfig = rdt.data
            window.sessionStorage.setItem(`partnerConfig`, JSON.stringify(partnerConfig));
            commit('INIT_CONFIG', partnerConfig);
          }
        }
      } else {
        commit('INIT_CONFIG', null);
      }
      // } else {
      //   partnerConfig = JSON.parse(JSON.stringify(tempData));
      // }
      console.log(12, partnerConfig);
      return partnerConfig;
    } else {
      return state.partnerConfig;
    }
  }
};

export default new Vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js